/**
 * Product gallery lightbox — shared controller for PDP and cart.
 */
(function () {
  const PDP_MODAL_ID = 'imageModal';
  const MOBILE_MQ = window.matchMedia('(max-width: 750px)');

  const GALLERY_MAIN_SELECTORS = [
    '.product-detail-block .slider-for',
    '.overview-product-slider .product-slider-for',
  ];

  const modalState = new WeakMap();
  let activeModalEl = null;
  let pdpResizeTimer;
  let pdpGalleryResizeTimer;

  function getState(modalEl) {
    if (!modalState.has(modalEl)) {
      modalState.set(modalEl, { lastSlideIndex: 0 });
    }
    return modalState.get(modalEl);
  }

  function getPdpModal() {
    return document.getElementById(PDP_MODAL_ID);
  }

  function isOpen(modalEl) {
    return modalEl?.getAttribute('aria-hidden') === 'false';
  }

  function moveModalToBody(modalEl) {
    if (modalEl && modalEl.parentElement !== document.body) {
      document.body.appendChild(modalEl);
    }
  }

  function getGallerySlider($context) {
    if (typeof jQuery === 'undefined') return null;
    const $ = jQuery;
    for (const selector of GALLERY_MAIN_SELECTORS) {
      const $slider = $context.closest(selector);
      if ($slider.length) return $slider;
    }
    return null;
  }

  function getPdpNavSliderSettings() {
    return {
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      infinite: false,
      variableWidth: true,
      responsive: [
        { breakpoint: 1199, settings: { slidesToShow: 4 } },
        { breakpoint: 991, settings: { slidesToShow: 4 } },
        { breakpoint: 767, settings: { slidesToShow: 4 } },
        { breakpoint: 575, settings: { slidesToShow: 4 } },
        { breakpoint: 447, settings: { slidesToShow: 4 } },
        { breakpoint: 389, settings: { slidesToShow: 4 } },
      ],
    };
  }

  function syncPdpGalleryActiveThumb($for, $nav) {
    if (!$for.hasClass('slick-initialized') || !$nav.hasClass('slick-initialized')) return;

    const mainIndex = $for.slick('slickCurrentSlide');

    $nav.find('.slick-slide').removeClass('is-gallery-active');
    $nav.find('.slider-box').removeAttr('aria-current');

    const $activeSlide = $nav
      .find('.slick-slide')
      .not('.slick-cloned')
      .filter(function () {
        return jQuery(this).data('slick-index') === mainIndex;
      })
      .first();

    $activeSlide.addClass('is-gallery-active');
    $activeSlide.find('.slider-box').attr('aria-current', 'true');
  }

  function bindPdpGallerySync($for, $nav) {
    const ns = '.pdpGallerySync';

    $for.off(`afterChange${ns}`);
    $nav.off(`afterChange${ns} click${ns}`);

    $for.on(`afterChange${ns}`, function (_event, _slick, current) {
      if ($nav.hasClass('slick-initialized')) {
        $nav.slick('slickGoTo', current, true);
      }
      syncPdpGalleryActiveThumb($for, $nav);
    });

    $nav.on(`afterChange${ns}`, function () {
      syncPdpGalleryActiveThumb($for, $nav);
    });

    $nav.on(`click${ns}`, '.slick-slide', function (event) {
      const $slide = jQuery(this);
      if ($slide.hasClass('slick-cloned')) return;

      const index = $slide.data('slick-index');
      if (typeof index !== 'number') return;

      event.preventDefault();
      $for.slick('slickGoTo', index);
    });

    syncPdpGalleryActiveThumb($for, $nav);
  }

  function teardownPdpNav($for, $nav) {
    $for.off('.pdpGallerySync');
    $nav.off('.pdpGallerySync');

    if ($nav.hasClass('slick-initialized')) {
      $nav.slick('unslick');
    }

    $nav.removeClass('product-slider-nav--native');
    $nav.children().removeClass('is-gallery-active');
    $nav.find('.slider-box').removeAttr('aria-current');
  }

  function setupPdpMobileNav($for, $nav) {
    teardownPdpNav($for, $nav);
    $nav.addClass('product-slider-nav--native');

    const $items = $nav.children();

    function setActive(index) {
      const safeIndex = Math.max(0, Math.min(index, $items.length - 1));

      $items.removeClass('is-gallery-active');
      $items.eq(safeIndex).addClass('is-gallery-active');
      $nav.find('.slider-box').removeAttr('aria-current');
      $items.eq(safeIndex).find('.slider-box').attr('aria-current', 'true');

      const el = $items.eq(safeIndex)[0];
      const navEl = $nav[0];
      if (!el || !navEl) return;

      const targetLeft = el.offsetLeft - (navEl.clientWidth - el.offsetWidth) / 2;
      navEl.scrollTo({
        left: Math.max(0, Math.min(targetLeft, navEl.scrollWidth - navEl.clientWidth)),
        behavior: 'smooth',
      });
    }

    $items.on('click.pdpGallerySync', function () {
      const index = jQuery(this).index();
      $for.slick('slickGoTo', index);
      setActive(index);
    });

    $for.on('afterChange.pdpGallerySync', function (_event, _slick, current) {
      setActive(current);
    });

    setActive($for.slick('slickCurrentSlide') || 0);
  }

  function setupPdpDesktopNav($for, $nav) {
    teardownPdpNav($for, $nav);
    $nav.slick(getPdpNavSliderSettings());
    bindPdpGallerySync($for, $nav);
  }

  function initOverviewProductGallery($for, $nav) {
    if ($for.hasClass('slick-initialized')) return;

    $for.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
    });

    $for.on('beforeChange', pauseGalleryMedia);

    if (!$nav.length) return;

    if (isMobileLayout()) {
      setupPdpMobileNav($for, $nav);
    } else {
      setupPdpDesktopNav($for, $nav);
    }
  }

  function refreshOverviewProductGalleries() {
    if (typeof jQuery === 'undefined') return;
    const $ = jQuery;
    const mobile = isMobileLayout();

    $('.overview-product-slider .product-slider-for').each(function () {
      const $for = $(this);
      if (!$for.hasClass('slick-initialized')) return;

      const $nav = $for.closest('.overview-product-slider').find('.product-slider-nav');
      if (!$nav.length) return;

      const isNative = $nav.hasClass('product-slider-nav--native');

      if (mobile && !isNative) {
        setupPdpMobileNav($for, $nav);
      } else if (!mobile && isNative) {
        setupPdpDesktopNav($for, $nav);
      }
    });
  }

  function initGallerySliders() {
    if (typeof jQuery === 'undefined') return;
    const $ = jQuery;

    const $detailFor = $('.product-detail-block .slider-for');
    const $detailNav = $('.product-detail-block .slider-nav');

    if ($detailFor.length && !$detailFor.hasClass('slick-initialized')) {
      $detailFor.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        asNavFor: $detailNav.length ? $detailNav : null,
      });
    }

    if ($detailNav.length && !$detailNav.hasClass('slick-initialized')) {
      $detailNav.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: $detailFor,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
      });
    }

    $('.overview-product-slider .product-slider-for').each(function () {
      initOverviewProductGallery($(this), $(this).closest('.overview-product-slider').find('.product-slider-nav'));
    });
  }

  function teardownMobileNav($modal) {
    if (typeof jQuery === 'undefined') return;
    const $ = jQuery;
    const $main = $modal.find('.modal-for-slider');
    const $nav = $modal.find('.modal-nav-slider');

    $main.off('afterChange.mobileNav');
    $nav.off('click.mobileNav');
    $nav.removeClass('modal-nav-slider--native');
    $nav.children().removeClass('is-nav-active');
    $modal.removeData('mobileNavSetActive');
  }

  function setupMobileNav($modal, $main, $nav) {
    if (typeof jQuery === 'undefined') return;
    const $ = jQuery;
    const state = getState($modal[0]);

    teardownMobileNav($modal);
    $nav.addClass('modal-nav-slider--native');

    const $items = $nav.children();

    function setActive(index) {
      const safeIndex = Math.max(0, Math.min(index, $items.length - 1));
      state.lastSlideIndex = safeIndex;
      $items.removeClass('is-nav-active');
      const $active = $items.eq(safeIndex);
      $active.addClass('is-nav-active');

      const el = $active[0];
      const navEl = $nav[0];
      if (!el || !navEl) return;

      const targetLeft = el.offsetLeft - (navEl.clientWidth - el.offsetWidth) / 2;
      navEl.scrollTo({
        left: Math.max(0, Math.min(targetLeft, navEl.scrollWidth - navEl.clientWidth)),
        behavior: 'smooth',
      });
    }

    $items.on('click.mobileNav', function () {
      const index = $(this).index();
      if ($main.hasClass('slick-initialized')) {
        $main.slick('slickGoTo', index, false);
      }
      setActive(index);
    });

    $main.on('afterChange.mobileNav', function (_event, _slick, current) {
      setActive(current);
    });

    $modal.data('mobileNavSetActive', setActive);
  }

  function destroyModalSliders(modalEl) {
    if (typeof jQuery === 'undefined' || !modalEl) return;
    const $ = jQuery;
    const $modal = $(modalEl);
    const $main = $modal.find('.modal-for-slider');
    const $nav = $modal.find('.modal-nav-slider');

    teardownMobileNav($modal);

    if ($main.length && $main.hasClass('slick-initialized')) {
      $main.off('beforeChange');
      $main.slick('unslick');
    }

    if ($nav.length && $nav.hasClass('slick-initialized')) {
      $nav.slick('unslick');
    }
  }

  function refreshModalSliders(modalEl) {
    if (typeof jQuery === 'undefined' || !modalEl) return;
    const $ = jQuery;

    $(modalEl)
      .find('.modal-for-slider, .modal-nav-slider')
      .each(function () {
        const $slider = $(this);
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
        }
      });
  }

  function isMobileLayout() {
    return MOBILE_MQ.matches;
  }

  function pauseGalleryMedia() {
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
  }

  function initModalSliders(modalEl) {
    if (typeof jQuery === 'undefined' || !modalEl) return;
    const $ = jQuery;
    const $modal = $(modalEl);
    const $main = $modal.find('.modal-for-slider');
    const $nav = $modal.find('.modal-nav-slider');
    const mobile = isMobileLayout();

    destroyModalSliders(modalEl);

    const slideCount = $main.find('.zoom_image').length;
    const useNavSlick = $nav.length && !mobile;

    if ($main.length) {
      $main.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: useNavSlick ? slideCount > 1 : false,
        adaptiveHeight: false,
        asNavFor: useNavSlick ? $nav : null,
      });

      $main.on('beforeChange', function (_event, _slick, _current, next) {
        getState(modalEl).lastSlideIndex = next;
        pauseGalleryMedia();
        const slide = $main.find('.slick-slide').not('.slick-cloned').get(next);
        if (slide) window.ProductImageZoom?.resetInSlide(slide);
      });
    }

    if ($nav.length) {
      if (mobile) {
        setupMobileNav($modal, $main, $nav);
      } else {
        $nav.slick({
          slidesToShow: Math.min(4, $nav.children().length),
          slidesToScroll: 1,
          asNavFor: $main,
          dots: false,
          arrows: false,
          focusOnSelect: true,
          vertical: true,
          verticalSwiping: true,
          infinite: false,
        });
      }
    }

    refreshModalSliders(modalEl);
  }

  function watchModalImages(modalEl) {
    if (typeof jQuery === 'undefined' || !modalEl) return;
    const $modal = jQuery(modalEl);

    modalEl.querySelectorAll('.modal-for-slider img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => refreshModalSliders(modalEl), { once: true });
    });
  }

  function goToModalSlide(modalEl, slideIndex) {
    if (typeof jQuery === 'undefined' || !modalEl) return;
    const $modal = jQuery(modalEl);
    const $main = $modal.find('.modal-for-slider');

    if ($main.hasClass('slick-initialized') && typeof slideIndex === 'number') {
      $main.slick('slickGoTo', slideIndex, false);
    }

    const setActive = $modal.data('mobileNavSetActive');
    if (typeof setActive === 'function') {
      setActive(slideIndex);
    }
  }

  function afterModalOpen(modalEl, slideIndex) {
    if (typeof jQuery === 'undefined' || !modalEl) return;

    initModalSliders(modalEl);
    window.ProductImageZoom?.initAll(modalEl);
    goToModalSlide(modalEl, slideIndex);
    watchModalImages(modalEl);
    requestAnimationFrame(() => refreshModalSliders(modalEl));
    setTimeout(() => refreshModalSliders(modalEl), 100);
    setTimeout(() => refreshModalSliders(modalEl), 400);
  }

  function closeModal(modalEl) {
    if (!modalEl || !isOpen(modalEl)) return;

    if (activeModalEl === modalEl) activeModalEl = null;

    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    pauseGalleryMedia();
    window.ProductImageZoom?.resetAllInModal(modalEl);

    if (typeof jQuery !== 'undefined') {
      destroyModalSliders(modalEl);
    }
  }

  function openModal(modalEl, slideIndex) {
    if (!modalEl) return;

    const state = getState(modalEl);
    state.lastSlideIndex = slideIndex;
    moveModalToBody(modalEl);
    activeModalEl = modalEl;

    if (isOpen(modalEl)) {
      afterModalOpen(modalEl, slideIndex);
      return;
    }

    modalEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    afterModalOpen(modalEl, slideIndex);
  }

  function resolvePdpSlideIndex(triggerEl) {
    let index = 0;
    const mediaId =
      triggerEl.getAttribute('data-media-id') ||
      triggerEl.querySelector('[data-media-id]')?.getAttribute('data-media-id');

    if (typeof jQuery !== 'undefined') {
      const $slider = getGallerySlider(jQuery(triggerEl));
      if ($slider && $slider.hasClass('slick-initialized')) {
        index = $slider.slick('slickCurrentSlide') || 0;
      }
    }

    const modal = getPdpModal();
    if (modal && mediaId) {
      modal.querySelectorAll('.modal-for-slider .zoom_image[data-media-id]').forEach((el, i) => {
        if (el.getAttribute('data-media-id') === mediaId) index = i;
      });
    }

    return Math.max(0, index);
  }

  function isIgnoredPdpClick(target) {
    return Boolean(
      target.closest(
        '.slick-arrow, .slick-dots, .zieny-ai-btn, .product-slider-nav, .showroom-modal-close, .product-image-modal-close, .product-meta-nav a, .share-button, .cart-image-gallery-view-btn, .cart-image-gallery-back-btn'
      )
    );
  }

  function bindPdpGalleryClicks() {
    document.addEventListener('click', (event) => {
      if (isIgnoredPdpClick(event.target)) return;

      const trigger = event.target.closest(
        '[data-product-image-open], .product-detail-block .slider-for .currentImg, .overview-product-slider .product-slider-for .product-gallery-main-img'
      );

      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(getPdpModal(), resolvePdpSlideIndex(trigger));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const trigger = event.target.closest('[data-product-image-open]');
      if (!trigger) return;

      event.preventDefault();
      openModal(getPdpModal(), resolvePdpSlideIndex(trigger));
    });
  }

  function bindPdpModalAnchorLinks() {
    const modal = getPdpModal();
    if (!modal) return;

    modal.querySelectorAll('[data-image-modal-anchor]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || !targetId.startsWith('#')) return;

        event.preventDefault();

        const scrollToTarget = () => {
          document.querySelector(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };

        if (isOpen(modal)) {
          closeModal(modal);
          requestAnimationFrame(scrollToTarget);
        } else {
          scrollToTarget();
        }
      });
    });
  }

  function bindModalClose(modalEl) {
    if (!modalEl || modalEl.dataset.closeBound === 'true') return;

    const closeBtn = modalEl.querySelector('.product-image-modal-close');

    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeModal(modalEl));
    }

    modalEl.addEventListener('click', (event) => {
      if (event.target === modalEl) closeModal(modalEl);
    });

    modalEl.dataset.closeBound = 'true';
  }

  function bindEscapeClose() {
    if (document.documentElement.dataset.productImageModalEscape === 'true') return;

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !activeModalEl || !isOpen(activeModalEl)) return;
      closeModal(activeModalEl);
    });

    document.documentElement.dataset.productImageModalEscape = 'true';
  }

  function handleModalResize() {
    if (!activeModalEl || !isOpen(activeModalEl)) return;

    clearTimeout(pdpResizeTimer);
    pdpResizeTimer = setTimeout(() => {
      afterModalOpen(activeModalEl, getState(activeModalEl).lastSlideIndex);
    }, 150);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function thumbUrl(src, width) {
    if (!src) return '';
    const normalized = src.startsWith('//') ? `https:${src}` : src;
    if (normalized.includes('cdn.shopify.com')) {
      const base = normalized.split('?')[0];
      return `${base}?width=${width || 140}`;
    }
    return normalized;
  }

  function buildGalleryHtml(slides) {
    if (!slides.length) return '';

    const navHtml =
      slides.length > 1
        ? `<div class="position-relative modal-nav-wrap">
            <div class="modal-nav-slider">
              ${slides
          .map(
            (slide, index) => `<div>
                <img
                  src="${escapeHtml(thumbUrl(slide.thumb || slide.src, 140))}"
                  alt="${escapeHtml(slide.alt)}"
                  data-media-position="${index}"
                  width="140"
                  height="140"
                  loading="lazy"
                  class="w-100 h-100 object-fit-cover"
                >
              </div>`
          )
          .join('')}
            </div>
          </div>`
        : '';

    const mainHtml = slides
      .map(
        (slide, index) => `<div class="zoom_image" data-slide-index="${index}">
          <div class="product-image-zoom" data-product-image-zoom>
            <div class="product-image-zoom__viewport">
              <img
                src="${escapeHtml(thumbUrl(slide.src, 2048))}"
                srcset="${escapeHtml(thumbUrl(slide.src, 800))} 800w, ${escapeHtml(thumbUrl(slide.src, 1200))} 1200w, ${escapeHtml(thumbUrl(slide.src, 2048))} 2048w"
                sizes="(min-width: 750px) 640px, calc(100vw - 64px)"
                alt="${escapeHtml(slide.alt)}"
                class="w-100 h-100 object-fit-cover product-image-zoom__img"
                loading="lazy"
              >
              <div class="product-image-zoom__lens" aria-hidden="true"></div>
            </div>
          </div>
        </div>`
      )
      .join('');

    return `${navHtml}<div class="modal-for-slider">${mainHtml}</div>`;
  }

  window.ProductImageModal = {
    open: openModal,
    close: closeModal,
    afterOpen: afterModalOpen,
    destroy: destroyModalSliders,
    refresh: refreshModalSliders,
    isOpen,
    moveToBody: moveModalToBody,
    buildGalleryHtml,
    bindClose: bindModalClose,
  };

  function handlePdpGalleryResize() {
    clearTimeout(pdpGalleryResizeTimer);
    pdpGalleryResizeTimer = setTimeout(refreshOverviewProductGalleries, 150);
  }

  function initPdp() {
    const modal = getPdpModal();
    if (modal) {
      moveModalToBody(modal);
      bindModalClose(modal);
      window.ProductImageZoom?.initAll(modal);
    }

    initGallerySliders();
    bindPdpGalleryClicks();
    bindPdpModalAnchorLinks();
    bindEscapeClose();

    window.addEventListener('resize', handleModalResize);
    window.addEventListener('resize', handlePdpGalleryResize);
    if (MOBILE_MQ.addEventListener) {
      MOBILE_MQ.addEventListener('change', handleModalResize);
      MOBILE_MQ.addEventListener('change', handlePdpGalleryResize);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdp);
  } else {
    initPdp();
  }
})();
